import { styled, Tabs, Tab } from '@mui/material';

// Styled Tabs container
export const StyledSideTabs = styled(Tabs)`
  .MuiTabs-flexContainer {
  }

  .MuiTabs-root {
    minheight: '3rem';
  }

  .MuiTabs-indicator {
    display: none; /* Hide default indicator */
  }
` as typeof Tabs;

export const StyledSideTab = styled(Tab)`
  background: transparent;
  border-radius: 1rem 1rem 0 0;
  border-bottom: 0.0625rem solid white;
  z-index: 4;
  opacity: 1;
  margin-left: 1rem;
  text-transform: capitalize;
  font-weight: '500';

  &.Mui-selected {
    border-bottom: none;
    z-index: 10;
    background-color: white;
    border: 1px solid #ebebeb;
    border-bottom: 1px solid white;
    color: #2f2f2f;
    font-weight: '500';
  }
` as typeof Tab;
